import { useCallback } from 'react';
import { Spinner } from '@flixbus/honeycomb-react';
import { Icon, IconTimelineAlt } from '@flixbus/honeycomb-icons-react';
import { DateTime } from 'luxon';

import { getVoucherActionLogs } from '../../../apis';
import { useVoucher } from '../../../context/VoucherProdiver';
import { VoucherActionLog } from '../../../types/VoucherActionLog';
import useQuery from '../../../hooks/useQuery';
import InfoDisplay from '../InfoDisplay';
import styles from '../voucher-info.module.scss';

const ACTION_TYPE_LABELS: Record<VoucherActionLog['actionType'], string> = {
  code_unmasked: 'Code revealed',
  enable: 'Enabled',
  disable: 'Disabled',
  update: 'Updated',
};

const VoucherActionLogs = () => {
  const { data } = useVoucher();
  const fetchLogs = useCallback(() => getVoucherActionLogs(data.id), [data.id]);
  const { data: logs, isPending, error } = useQuery(fetchLogs);

  const title = (
    <>
      <Icon appearance={'secondary'} size={4} InlineIcon={IconTimelineAlt} />
      {' Action logs'}
    </>
  );

  const fields = (() => {
    if (isPending) return [{ value: <Spinner extraClasses={styles.spinner} size={'xl'} /> }];
    if (error) return [{ value: 'Failed to load action logs. Please try again.' }];
    if (!logs || logs.length === 0) return [{ value: 'No action logs for this voucher.' }];

    return logs.map(log => ({
      label: `${log.user} | ${DateTime.fromISO(log.createdDate).toFormat('dd.MM.yyyy HH:mm')}`,
      value: ACTION_TYPE_LABELS[log.actionType] ?? log.actionType,
    }));
  })();

  return (
    <div className={styles.container}>
      <InfoDisplay title={title} fields={fields} />
    </div>
  );
};

export default VoucherActionLogs;
